import styled from 'styled-components';
function Header() {
  return (
    <Wrap>
      <Logo></Logo>
      <SearchNaver
        href="https://search.naver.com/search.naver?where=nexearch&sm=top_hty&fbm=0&ie=utf8&query=법률사무소+훈+권오훈변호사"
        target="_blank"
        title="Search Hoon"
      >
        <img src="/images/search_img.png" />
      </SearchNaver>
    </Wrap>
  );
}
export default Header;
const SearchNaver = styled.a`
  display: block;
  margin-right: 2em;
  color: #f1bf78;
  width: 100px;
  img {
    width: 100%;
  }
`;
const Logo = styled.div`
  background: url('/images/logo_2.png') no-repeat;
  background-size: 100%;
  width: 60px;
  height: 60px;
  z-index: 12;
  margin-left: 2em;
  cursor: pointer;
`;
const Wrap = styled.div`
  position: fixed;
  top: 2em;
  left: 0;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: space-between;
`;
